import { styled } from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';

import { media } from '../media';

function getVerticalPadding({ verticalPadding }: Pick<Props, 'verticalPadding'>) {
  if (verticalPadding === 'none') return 0;
  if (verticalPadding === 'sm') return 16;
  return 24;
}

type Props = {
  borderBottom?: boolean;
  verticalPadding?: 'sm' | 'none';
};

export const ContentContainer = styled.div<Props>`
  padding-left: 16px;
  padding-right: 16px;
  padding-top: ${getVerticalPadding}px;
  padding-bottom: ${getVerticalPadding}px;
  border: 0 solid ${color.border};
  border-bottom-width: ${({ borderBottom }) => (borderBottom ? '1px' : '0')};

  @media ${media.sm} {
    padding-left: 24px;
    padding-right: 24px;
  }
`;
